import { FunctionComponent, ReactElement, useContext, useEffect, useRef, useState } from 'react';
import { apiClient } from '../../adapters/api-client';
import { Loader } from '../../components/Loader/Loader';
import ScrollToTop from '../../components/ScrollToTop';
// import { ScoreResponse } from '../../adapters/api-client/subscription/Subscription.model';
import { GeoLoc, TRACKER_TYPE } from '../../constants/constants';
import { useTracker } from '../../hooks/useWebAnalyse';
import { store } from '../../store/store';
import { updateStore } from '../../store/store.actions';
import { Score } from '../../store/store.model';
import { getQueryParams } from '../../utils/QueryParamsUtils';
import { ResponsePageType } from '../../utils/ResponsePageModel';
import { Step } from '../../utils/Steps';
import { useStep } from './../../hooks/useStep';
import GreenScoreDemat from './components/GreenScoreDemat';
import RedScore from './components/RedScore';

export interface ResponseProps {
  currentStep: Step;
}

const Response: FunctionComponent<Record<string, never>> = (): ReactElement => {
  const { dispatch, state, dispatchGeoLoc, geoLoc } = useContext(store);
  useEffect(() => {
    if (geoLocation === 'cmoi' || geoLocation === 'CMOI') {
      dispatchGeoLoc(GeoLoc.CMOI);
    } else if (geoLocation === 'cmag' || geoLocation === 'CMAG') {
      dispatchGeoLoc(GeoLoc.CMAG);
    } else {
      dispatchGeoLoc(GeoLoc.CTLM);
    }
  });
  const { stepData } = useStep(Step.RESPONSE);
  const loaderRef = useRef(null);
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const [scoreResponseService, setScoreResponseService] = useState<any>();
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const { geoLocation } = getQueryParams();
  const responseData = {
    budget: {
      expenses: {
        rentAmount: state?.housing?.housingCode === 'L' ? state?.budget?.expenses?.rentAmount : 0,
      },
      income: {
        holderSalaryAmount: state?.budget?.income?.holderSalaryAmount,
      },
    },
    consents: {
      gdprFlag: state?.consents?.dossierBoolean,
      optInFlag: state?.consents?.cetelemProject,
    },
    familySituation: {
      childrenCount: state?.familySituation?.childrenCount,
      maritalStatusCode: state?.familySituation?.maritalStatusCode,
    },
    holder: {
      contact: {
        additionalAddress: state?.holder?.contact?.streetAddress,
        addressMail: state?.holder?.contact?.addressMail,
        cityAddress: state?.holder?.contact?.cityAddress.name,
        homePhone: state?.holder?.contact?.homePhone,
        mobilePhone: state?.holder?.contact?.mobilePhone,
        streetAddress: state?.holder?.contact?.additionalAddress,
        zipCode: state?.holder?.contact?.zipCode,
      },
      customerFlag: state?.consents?.cetelemProject,
      identity: {
        birthCountryCode: state?.holder?.identity?.birthCountry?.countryCode,
        birthDate: state?.holder?.identity?.birthDate,
        birthDepartmentCode: state?.holder?.identity?.birthDepartment?.code,
        birthName: state?.holder?.identity?.birthName,
        civility: state?.holder?.identity?.civility,
        firstname: state?.holder?.identity?.firstname,
        lastname: state?.holder?.identity?.lastname,
        nationalityCountryCode: state?.holder?.identity?.nationality?.countryCode,
      },
      job: {
        activitySectorCode: state?.holder?.job?.activitySectorCode,
        employmentContractCode: state?.holder?.job?.employmentContractCode || '',
      },
    },
    housing: {
      housingCode: state?.housing?.housingCode,
    },
    loans: {
      consumerLoans: state?.loans?.consumerLoans,
      newProjectAmount: state?.loans?.newProjectAmount || 0,
      realEstateLoans: state?.loans?.realEstateLoans,
    },
    technicalData: {
      geoLoc: geoLoc,
    },
  };
  const getScore = async () => {
    try {
      // if (res && res.statusCode === 204) {
      const response = await apiClient().subscription.postSubscriptionScore(responseData);
      if (response) {
        setScoreResponseService(response?.data);
        calculateResponsePageType(response?.data);
      }
      // }
    } catch (err) {
      //TODO
    } finally {
      setIsLoading(false);
    }
  };
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const calculateResponsePageType = (response: any) => {
    let type;
    if (response) {
      if (
        response.scoreLight === Score.RED ||
        (response.scoreLight === Score.GREEN && geoLoc !== 'CTLM') ||
        (response.scoreLight === Score.GREEN && response.amountCreditFlag === undefined && geoLoc === 'CTLM')
      ) {
        type = ResponsePageType.NONE;
      } else if (response.scoreLight === Score.GREEN && response.amountCreditFlag === true) {
        type = ResponsePageType.IMMO;
      } else if (response.scoreLight === Score.GREEN && response.amountCreditFlag === false) {
        type = ResponsePageType.CONSO;
      }
      dispatch(
        updateStore({
          responseInfo: { responsePageType: type },
        }),
      );
    }
  };

  useEffect(() => {
    // call getScore
    getScore();
  }, []);

  //web analyse hook
  useTracker(
    [TRACKER_TYPE.P3],
    stepData.webAnalyseDetails,
    scoreResponseService,
    undefined,
    undefined,
    geoLoc,
    responseData.housing,
    responseData.loans,
    responseData.consents,
  );

  const renderSwitch = () => {
    switch (state?.responseInfo?.responsePageType) {
      case ResponsePageType.IMMO:
        return <GreenScoreDemat score={scoreResponseService}></GreenScoreDemat>;
      case ResponsePageType.CONSO:
        return <GreenScoreDemat score={scoreResponseService}></GreenScoreDemat>;
      case ResponsePageType.NONE:
        return <RedScore></RedScore>;
      default:
        return <></>;
    }
  };
  return isLoading ? (
    <>
      <div ref={loaderRef}>
        <Loader message="Nous étudions votre dossier, merci de patienter" />
      </div>
      <ScrollToTop elementRef={loaderRef}></ScrollToTop>
    </>
  ) : (
    renderSwitch()
  );
};

export default Response;
